export const getDistinctFamilyTreeNamesApi = async (axiosPrivate) => {
	const response = await axiosPrivate.get("/admin/profile-claim-requests/family-tree-names");
	return response.data;
};

export const getPaginatedClaimRequestsApi = async (axiosPrivate, payload) => {
	const response = await axiosPrivate.post("/admin/profile-claim-requests/query", payload);
	return response.data;
};

export const checkAccountVerificationStatusApi = async (axiosPrivate, accountId) => {
	const response = await axiosPrivate.post("/admin/profile-claim-requests/check-verification-status", {accountId});
	return response.data;
};

export const updateMatchedAccountContactApi = async (axiosPrivate, id, payload) => {
	const response = await axiosPrivate.patch(
		`/admin/profile-claim-requests/${id}/update-contact`, payload
	);
	return response.data;
};

export const updateClaimRequestApi = async (axiosPrivate, id, payload) => {
	const response = await axiosPrivate.patch(`/admin/profile-claim-requests/${id}`, payload);
	return response.data;
};

export const exportClaimRequestsApi = async (axiosPrivate, payload) => {
	const response = await axiosPrivate.post("/admin/profile-claim-requests/export", payload, {
		responseType: "blob",
	});
	return response.data;
};